export const HOME_ROUTE = '/'
export const PORTFOLIO_ROUTE = '/portfolio'
export const POLICY_ROUTE = '/policy'
export const NEWS_ROUTE = '/news'
export const ADMIN_ROUTE = '/admin'
export const ADMIN_HOME_SLIDER_ROUTE = '/admin/home-slider'
export const ADMIN_WORKS_ROUTE = '/admin/works'
export const LOGIN_PAGE_ROUTE = '/auth'
